export const GAME_CONFIG = {
    name: "Topster",
    tagline: "Remets la musique dans le temps",
    defaultWinTarget: 10,
    maxPlayers: 8,
    defaultRoundDurationSeconds: 60,
    maxClipDurationSeconds: 30,
    minSongsToStart: 3,
    initialCardCountsTowardWin: false,
    roomCodeLength: 6,
    roomCodeAlphabet: "ABCDEFGHJKLMNPQRSTUVWXYZ23456789",
    audioSyncDelayMs: 800,
    reconnectMinutes: 5,
};
export const DEFAULT_ROOM_SETTINGS = {
    winTarget: GAME_CONFIG.defaultWinTarget,
    maxPlayers: GAME_CONFIG.maxPlayers,
    roundDurationSeconds: GAME_CONFIG.defaultRoundDurationSeconds,
    singleListen: false,
    mode: "individual",
    hintsEnabled: false,
    maxHintsPerPlayer: 3,
    continueAfterWin: true,
    gameKind: "timeline",
};
